import React from "react";

const Stepper = ({ steps, activeStep }) => {
  return (
    <div className="stepper">
      {steps.map((step, index) => (
        <div key={index} className="stepper-step">
          <div
            className={`step-circle ${
              index < activeStep
                ? "complete"
                : index === activeStep
                ? "active"
                : "inactive"
            }`}
          >
            {index + 1}
          </div>
          <span className="step-title">{step.title}</span>
          <div
            className={
              index === 0
                ? "step-line-start"
                : index === steps.length - 1
                ? "step-line-end"
                : "step-line"
            }
          />
        </div>
      ))}
    </div>
  );
};

export default Stepper;
